(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eb01-simulator"] && !Shopify.designMode) return;
  try {
    
function makePack(cards, random = Math.random, guaranteedAlternative = false) {
 const normal = [...new Map(cards.filter(c => !c.alternative).map(c => [c.id,c])).values()];
 const alts = cards.filter(c => c.alternative);
 const pool = rarity => normal.filter(c => rarity.includes(c.rarity));
 const pick = values => {
  if (!values.length) throw new Error('Incomplete collection');
  return values[Math.floor(random()*values.length)];
 };
 const shuffle = values => {
  const result = [...values];
  for(let i=result.length-1;i>0;i--){const j=Math.floor(random()*(i+1));[result[i],result[j]]=[result[j],result[i]];}
  return result;
 };
 if(pool(['C','UC','P']).length<11 || pool(['R']).length<2 || !pool(['SR']).length || !pool(['SEC']).length) throw new Error('Incomplete collection');
 const roll = random();
 const leaderHit = random() < .10;
 let last;
 if((guaranteedAlternative || roll>=.93) && alts.length){
  const ids = [...new Set(alts.map(c=>c.id))];
  const id = pick(ids);
  last=pick(alts.filter(c=>c.id===id));
 } else last=pick(pool([roll<.63||roll>=.93?'R':roll<.88?'SR':'SEC']));
 const used = new Set([last.id]);
 const leaders=pool(['L']).filter(c=>!used.has(c.id));
 const leader=leaderHit&&leaders.length?pick(leaders):null;
 if(leader)used.add(leader.id);
 const rare=pick(pool(['R']).filter(c=>!used.has(c.id)));used.add(rare.id);
 const first=shuffle(pool(['C','UC','P']).filter(c=>!used.has(c.id))).slice(0,leader?9:10);
 return [...first,...(leader?[leader]:[]),rare,last].map(card=>{
  if(card.alternative)return card;
  const prints=cards.filter(c=>!c.alternative&&c.id===card.id);
  return prints.length>1?pick(prints):card;
 });
}
function makeGodPack(cards, random = Math.random) {
 const fixedIds = ['OP13-080','OP13-083','OP13-084','OP13-089','OP13-091','OP13-079'];
 const fixed = fixedIds.map(id => cards.find(c => c.id === id && c.godPack));
 if(fixed.some(c => !c)) throw new Error('Incomplete God Pack');
 const used = new Set(fixedIds);
 const available = cards.filter(c => c.alternative && !c.manga && !used.has(c.id));
 const first = [];
 for(let i=0;i<6;i++) {
  const ids = [...new Set(available.filter(c=>!used.has(c.id)).map(c=>c.id))];
  if(!ids.length) throw new Error('Incomplete God Pack');
  const id=ids[Math.floor(random()*ids.length)];
  const prints=available.filter(c=>c.id===id);
  first.push(prints[Math.floor(random()*prints.length)]);used.add(id);
 }
 return [...first,...fixed];
}
function makeCollectionPack(collection, random, guaranteedAlternative, godChance) {
 const rate=Math.max(0,Math.min(100,Number(godChance)||0))/100;
 if(collection.id==='OP13' && rate>0 && random()<rate) return makeGodPack(collection.cards,random);
 return makePack(collection.cards,random,guaranteedAlternative);
}

class PokeglyphPackSimulator extends HTMLElement {
 connectedCallback() {
  if (this.ready) return;
  this.ready = true;
  this.data = JSON.parse(this.querySelector('[data-sim-data]').textContent);
  const releaseOrder = ["OP01", "OP02", "OP03", "OP04", "OP05", "OP06", "EB01", "OP07", "OP08", "PRB01", "OP09", "OP10", "EB02", "OP11", "OP12", "PRB02", "OP13", "OP14", "EB03", "OP15", "OP16", "OP17"];
  const releaseRank = id => {const rank=releaseOrder.indexOf(id.replaceAll('-', ''));return rank<0?releaseOrder.length:rank;};
  this.data.collections.sort((a,b)=>releaseRank(a.id)-releaseRank(b.id));
  const selector=this.querySelector('[data-collection]');
  [...selector.options].sort((a,b)=>releaseRank(a.value)-releaseRank(b.value)).forEach(option=>selector.append(option));
  this.words = JSON.parse(this.querySelector('[data-sim-words]').textContent);
  this.collectionSelect = this.querySelector('[data-collection]');
  this.activeCollection = this.data.collections.find(c=>c.id===this.dataset.defaultCollection)||this.data.collections[0];
  this.collectionSelect.value=this.activeCollection.id;
  this.stage = this.querySelector('[data-stage]');
  this.openButton = this.querySelector('[data-open]');
  this.nextButton = this.querySelector('[data-next]');
  this.resetButton = this.querySelector('[data-reset]');
  this.image = this.querySelector('[data-card-image]');
  this.cardTilt = this.querySelector('[data-card-tilt]');
  this.stackLayers=this.querySelector('[data-stack-layers]');
  this.turning=false;
  this.progress = this.querySelector('[data-progress]');
  this.status = this.querySelector('[data-status]');
  this.results = this.querySelector('[data-results]');
  this.grid = this.querySelector('[data-results-grid]');
  this.code = this.querySelector('[data-card-code]');
  this.rarity = this.querySelector('[data-rarity]');
  this.motion = matchMedia('(prefers-reduced-motion: reduce)');
  this.timers = new Set();
  this.phase = 'idle';
  this.openButton.addEventListener('click', () => this.open());
  this.openButton.addEventListener('pointermove', event => { if(this.motion.matches || event.pointerType === 'touch')return;const rect=this.openButton.getBoundingClientRect();this.openButton.style.setProperty('--pack-light', (20+60*Math.max(0,Math.min(1,(event.clientX-rect.left)/rect.width)))+'%');});
  this.openButton.addEventListener('pointerleave', () => this.openButton.style.removeProperty('--pack-light'));
  this.nextButton.addEventListener('click', () => this.advance());
  this.nextButton.addEventListener('pointermove', event => this.tiltCard(event));
  this.nextButton.addEventListener('pointerleave', () => this.resetTilt());
  this.nextButton.addEventListener('pointercancel', () => this.resetTilt());
  this.nextButton.addEventListener('blur', () => this.resetTilt());
  this.resetButton.addEventListener('click', () => this.reset());
  this.collectionSelect.addEventListener('change', () => {
   const chosen = this.data.collections.find(collection => collection.id === this.collectionSelect.value);
   if (!chosen) return;
   this.activeCollection = chosen;
   this.reset();
   this.updateCollection();
  });
  this.shopLink=this.querySelector('[data-shop-collection]');
  this.shopBase=this.shopLink.getAttribute('href').split('?')[0];
  this.zoomDialog=this.querySelector('[data-zoom]');
  this.querySelector('[data-reveal-all]').addEventListener('click',()=>{if(this.phase==='revealing')this.finish();});
  this.querySelector('[data-zoom-close]').addEventListener('click',()=>this.zoomDialog.close());
  this.addEventListener('keydown',event=>{
   if(this.phase!=='revealing'||event.altKey||event.ctrlKey||event.metaKey||event.target.closest('input,select,textarea,dialog')||event.target.isContentEditable)return;
   if(event.target.closest('button')&&event.target.closest('button')!==this.nextButton)return;
   if(['ArrowRight','ArrowLeft',' '].includes(event.key)){event.preventDefault();if(event.repeat)return;if(event.key==='ArrowLeft'){if(this.index>0)this.turnCard(-1);}else this.advance();}
  });
  this.updateCollection();
  this.openButton.disabled = false;
 }
 tiltCard(event) {
  if(this.dataset.tilt==='false' || this.phase !== 'revealing' || this.motion.matches || event.pointerType !== 'mouse') {this.resetTilt();return;}
  const rect=this.nextButton.getBoundingClientRect();
  const top=rect.top+this.cardTilt.offsetTop;
  const width=this.cardTilt.offsetWidth, height=this.cardTilt.offsetHeight;
  const left=rect.left+(rect.width-width)/2;
  if(!width || !height || event.clientX<left || event.clientX>left+width || event.clientY<top || event.clientY>top+height){this.resetTilt();return;}
  const x=(event.clientX-left)/width, y=(event.clientY-top)/height;
  this.cardTilt.dataset.tilting='true';
  this.cardTilt.style.setProperty('--tilt-x',((.5-y)*Number(this.dataset.tiltAmount ?? 12)*2).toFixed(2)+'deg');
  this.cardTilt.style.setProperty('--tilt-y',((x-.5)*Number(this.dataset.tiltAmount ?? 12)*2).toFixed(2)+'deg');
 }
 resetTilt() {
  if(!this.cardTilt)return;
  this.cardTilt.dataset.tilting='false';
  this.cardTilt.style.setProperty('--tilt-x','0deg');
  this.cardTilt.style.setProperty('--tilt-y','0deg');
 }
 countKey() {return 'pokeglyph-pack-count-v1:'+this.activeCollection.id;}
 readCount() {
  const key=this.countKey();
  window.pokeglyphPackCounts=window.pokeglyphPackCounts||{};
  let count=window.pokeglyphPackCounts[key]||0;
  try {const stored=Number(localStorage.getItem(key));if(Number.isSafeInteger(stored)&&stored>=0)count=Math.max(count,stored);}catch(error){}
  return count;
 }
 saveCount(count) {
  const key=this.countKey();window.pokeglyphPackCounts=window.pokeglyphPackCounts||{};
  window.pokeglyphPackCounts[key]=count;
  try {localStorage.setItem(key,String(count));}catch(error){}
 }
 updateCollection() {
  const collection = this.activeCollection;
  this.querySelectorAll('[data-pack-art]').forEach(art=>{art.hidden=art.dataset.packArt!==collection.id;});
  this.querySelector('[data-set-code]').textContent = collection.id.replace(/^([A-Z]{2,3})(\d+)$/, '$1-$2');
  this.querySelector('[data-set-name]').textContent = collection.name.replace(/^[A-Z]{2,3}-?\d+\s*[·:–—-]\s*/, '');
  this.querySelector('[data-set-number]').textContent = String(this.data.collections.indexOf(collection)+1).padStart(2,'0');
  this.querySelector('[data-set-count]').textContent = this.words.count.replace('__COUNT__',new Set(collection.cards.map(card=>card.id)).size);
  this.querySelector('[data-pack-code]').textContent = collection.id.replace(/^([A-Z]{2,3})(\d+)$/, '$1-$2');
  this.querySelector('[data-experience]').textContent = this.words.experience+' '+collection.id.replace(/^([A-Z]{2,3})(\d+)$/, '$1-$2');
 }
 later(fn, duration) {
  const timer = setTimeout(() => {this.timers.delete(timer); if(this.isConnected) fn();}, duration);
  this.timers.add(timer);
 }
 disconnectedCallback() {this.cancelTurn();this.resetTilt();this.timers?.forEach(clearTimeout);this.timers?.clear();}
 burst(rarity) {
  if (this.motion.matches || this.dataset.particles==='false') return;
  const colors = {ALT:'#ba64db',C:'#cf6373',UC:'#cf6373',R:'#981118',SR:'#db9b24',SEC:'#c377e6',L:'#3f92be'};
  const count = Math.round((['SEC','ALT'].includes(rarity) ? 40 : ['SR','L'].includes(rarity) ? 28 : 16)*Number(this.dataset.particleAmount ?? 100)/100);
  for(let i=0;i<count;i++){
   const dot = document.createElement('i');dot.className='eb-spark';dot.setAttribute('aria-hidden','true');
   const angle = Math.random()*Math.PI*2, distance = 80+Math.random()*180;
   dot.style.setProperty('--dx',Math.cos(angle)*distance+'px');dot.style.setProperty('--dy',Math.sin(angle)*distance+'px');
   dot.style.setProperty('--spark',colors[rarity]||colors.R);dot.style.setProperty('--delay',Math.random()*.15+'s');
   if(this.phase==='revealing'){
    const cardRect=this.cardTilt.getBoundingClientRect(),stageRect=this.stage.getBoundingClientRect();
    const side=i%4,along=Math.random();
    const x=side===0?0:side===1?cardRect.width:along*cardRect.width;
    const y=side===2?0:side===3?cardRect.height:along*cardRect.height;
    dot.style.left=(cardRect.left-stageRect.left+x)+'px';dot.style.top=(cardRect.top-stageRect.top+y)+'px';
    dot.style.setProperty('--dx',(side===0?-1:side===1?1:Math.cos(angle))*distance+'px');
    dot.style.setProperty('--dy',(side===2?-1:side===3?1:Math.sin(angle))*distance+'px');
   }
   this.stage.append(dot);this.later(()=>dot.remove(),1300);
  }
 }
 async open() {
  if(this.phase !== 'idle')return;
  this.phase='opening';this.openButton.disabled=true;this.status.textContent=this.words.opening;
  const nextCount=this.readCount()+1;
  try {this.pack=makeCollectionPack(this.activeCollection,Math.random,nextCount%10===0,this.dataset.godPackChance);} catch(error) {this.status.textContent=this.words.error;this.phase='idle';this.openButton.disabled=false;return;}
  this.saveCount(nextCount);
  this.pack.forEach(card=>{const image=new Image();image.src=card.url;});
  this.dataset.state='opening';this.burst('R');
  this.later(()=>{this.index=0;this.phase='revealing';this.dataset.state='cards';this.nextButton.hidden=false;this.showCard();this.nextButton.focus({preventScroll:true});},this.motion.matches||this.dataset.animations==='false'?0:1050);
 }
 showCard(keepPose=false) {
  if(!keepPose)this.resetTilt();
  this.renderStack();
  const card=this.pack[this.index];
  this.stage.dataset.rarity=card.alternative?'ALT':card.rarity;
  this.code.textContent=card.id;this.rarity.textContent=card.rarity+(card.alternative?' · '+this.words.alternative:'');
  this.image.hidden=false;this.image.alt=(card.name ? card.name+' · ' : '')+card.id+' · '+card.rarity+(card.alternative?' · '+this.words.alternative:'');
  this.image.onerror=()=>{this.image.hidden=true;this.status.textContent=this.words.image_error+' '+card.id;};
  this.image.src=card.url;
  const text=this.words.progress.replace('__N__',this.index+1);
  this.progress.textContent=text;this.status.textContent=text+' · '+card.id+' · '+card.rarity+(card.alternative?' · '+this.words.alternative:'');
  this.nextButton.setAttribute('aria-label',this.index===11?this.words.summary:this.words.next);
  this.querySelector('[data-next-label]').textContent=this.index===11?this.words.summary:this.words.next;
  this.nextButton.classList.remove('eb-reveal');if(!keepPose){void this.nextButton.offsetWidth;this.nextButton.classList.add('eb-reveal');}
  this.burst(card.alternative?'ALT':card.rarity);
 }
 renderStack() {
  this.incoming?.remove();this.incoming=null;this.incomingImage=null;
  this.stackLayers.replaceChildren();
  for(let i=this.pack.length-1;i>this.index;i--){
   const layer=document.createElement('span');layer.className='eb-stack-layer';
   layer.style.setProperty('--depth',String(i-this.index));
   layer.dataset.alternative=String(Boolean(this.pack[i].alternative));
   this.stackLayers.append(layer);
  }
  if(this.index+1<this.pack.length)this.prepareIncoming(this.pack[this.index+1]);
 }
 prepareIncoming(card){
  if(!this.incoming){
   this.incoming=document.createElement('span');this.incoming.className='eb-incoming-card';this.incoming.setAttribute('aria-hidden','true');
   this.incomingImage=document.createElement('img');this.incomingImage.alt='';this.incomingImage.width=480;this.incomingImage.height=672;
   this.incoming.append(this.incomingImage);this.cardTilt.append(this.incoming);
  }
  this.incomingImage.src=card.url;
 }
 cancelTurn(){
  this.turnToken=(this.turnToken||0)+1;
  this.turnAnimation?.cancel();this.turnAnimation=null;this.turning=false;
  this.incoming?.remove();this.incoming=null;this.incomingImage=null;
  this.nextButton?.removeAttribute('aria-busy');
 }
 async turnCard(direction=1){
  if(this.phase!=='revealing'||this.turning)return;
  if(this.index+direction<0)return;
  this.turning=true;this.nextButton.setAttribute('aria-busy','true');
  const token=this.turnToken=(this.turnToken||0)+1;
  const target=this.pack[this.index+direction];
  if(target){
   if(direction!==1||!this.incomingImage)this.prepareIncoming(target);
   const preview=this.incomingImage;
   if(preview.decode){try{await preview.decode();}catch(error){}}
   if(token!==this.turnToken||this.phase!=='revealing'||!this.isConnected)return;
   this.incoming.dataset.visible='true';
  }
  const frame=this.cardTilt.querySelector('.eb-card-frame');
  this.nextButton.classList.remove('eb-reveal');
  if(!this.motion.matches&&this.dataset.animations!=='false'&&frame.animate){
   this.turnAnimation=frame.animate([
    {transform:'translate3d(0,0,1px) rotate(0deg)',opacity:1},
    {transform:'translate3d('+direction*32+'%, -4%, 45px) rotate('+direction*8+'deg)',opacity:1,offset:.45},
    {transform:'translate3d('+direction*108+'%, 8%, 70px) rotate('+direction*19+'deg)',opacity:0}
   ],{duration:300,easing:'cubic-bezier(.3,.05,.25,1)',fill:'forwards'});
   try{await this.turnAnimation.finished;}catch(error){return;}
  }
  if(token!==this.turnToken||this.phase!=='revealing'||!this.isConnected)return;
  this.turnAnimation?.cancel();this.turnAnimation=null;this.turning=false;this.nextButton.removeAttribute('aria-busy');
  if(this.index+direction>=this.pack.length){this.finish();return;}
  this.index+=direction;this.showCard(true);
 }
 advance() {
  if(this.phase!=='revealing'||this.turning)return;
  this.turnCard(1);
 }
 finish() {
  this.cancelTurn();
  this.resetTilt();
  this.shopLink.hidden=false;this.shopLink.href=this.shopBase+'?type=product&q='+encodeURIComponent(this.activeCollection.id.replace(/^([A-Z]{2,3})(\d+)$/, '$1-$2'));
  this.phase='complete';this.dataset.state='complete';this.nextButton.hidden=true;this.results.hidden=false;this.grid.replaceChildren();
  this.pack.forEach((card,i)=>{
   const item=document.createElement('li');item.dataset.rarity=card.alternative?'ALT':card.rarity;
   const img=document.createElement('img');img.src=card.url;img.alt=(card.name ? card.name+' · ' : '')+card.id+' · '+card.rarity+(card.alternative?' · '+this.words.alternative:'');img.width=480;img.height=672;img.loading='lazy';
   const caption=document.createElement('span');caption.textContent=(i+1)+'. '+card.id+' · '+card.rarity+(card.alternative?' · '+this.words.alternative:'');
   const zoom=document.createElement('button');zoom.type='button';zoom.className='eb-zoom-trigger';zoom.setAttribute('aria-label',this.words.zoom+' · '+card.id);zoom.append(img);zoom.addEventListener('click',()=>{const large=this.querySelector('[data-zoom-image]');large.src=card.url;large.alt=img.alt;this.zoomDialog.showModal();});
   item.append(zoom,caption);this.grid.append(item);
  });
  this.progress.textContent=this.words.complete;this.status.textContent=this.words.complete;
  this.resetButton.hidden=false;this.resetButton.focus({preventScroll:true});
 }
 reset() {
  this.cancelTurn();this.stackLayers?.replaceChildren();
  if(this.shopLink)this.shopLink.hidden=true;this.zoomDialog?.close();
  this.resetTilt();
  this.timers.forEach(clearTimeout);this.timers.clear();this.querySelectorAll('.eb-spark').forEach(n=>n.remove());
  this.phase='idle';this.dataset.state='idle';delete this.stage.dataset.rarity;
  this.results.hidden=true;this.resetButton.hidden=true;this.nextButton.hidden=true;this.openButton.disabled=false;
  this.progress.textContent=this.words.ready;this.status.textContent=this.words.ready;
  this.openButton.focus({preventScroll:true});
 }
}
if(!customElements.get('pokeglyph-pack-simulator'))customElements.define('pokeglyph-pack-simulator',PokeglyphPackSimulator);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["final-enhancements"]) return;
  try {
    
(() => {
 if(window.pokeglyphFinalEffects)return;
 window.pokeglyphFinalEffects=true;
 const motion=matchMedia('(prefers-reduced-motion: no-preference)');
 const fine=matchMedia('(hover:hover) and (pointer:fine)');
 const selector='.product-card-wrapper,.collection-card-wrapper';
 const enabled=()=>document.querySelector('.pf-enhancements')?.dataset.cursorParticles==='true';
 let timer=null,active=null,x=0,y=0;
 const stop=()=>{if(timer!==null)clearInterval(timer);timer=null;active=null;document.querySelectorAll('.pf-spark').forEach(spark=>spark.remove());};
 const emit=()=>{
  if(!enabled()||!active||!active.isConnected||document.hidden||!motion.matches||!fine.matches){stop();return;}
  if(document.elementFromPoint(x,y)?.closest(selector)!==active){stop();return;}
  const rect=active.getBoundingClientRect();
  const px=x-rect.left,py=y-rect.top;
  active.style.setProperty('--pf-x',px+'px');
  active.style.setProperty('--pf-y',py+'px');
  for(let i=0;i<2;i++){
   if(document.querySelectorAll('.pf-spark').length>=24)break;
   const spark=document.createElement('i');
   spark.className='pf-spark';
   spark.setAttribute('aria-hidden','true');
   spark.style.left=Math.max(0,Math.min(rect.width,px+Math.random()*30-15))+'px';
   spark.style.top=Math.max(0,Math.min(rect.height,py+Math.random()*24-12))+'px';
   spark.style.setProperty('--pf-dx',(Math.random()*60-30)+'px');
   active.append(spark);
   setTimeout(()=>spark.remove(),750);
  }
 };
 const track=event=>{
  if(!enabled()||!motion.matches||!fine.matches||event.pointerType==='touch'){stop();return;}
  const card=event.target.closest?.(selector);
  if(!card){stop();return;}
  x=event.clientX;y=event.clientY;
  if(active===card&&timer!==null)return;
  stop();active=card;emit();
  if(active)timer=setInterval(emit,85);
 };
 document.addEventListener('pointerover',track,{passive:true});
 document.addEventListener('pointermove',track,{passive:true});
 document.addEventListener('pointerout',event=>{
  if(active&&!active.contains(event.relatedTarget))stop();
 },{passive:true});
 document.addEventListener('pointercancel',stop,{passive:true});
 document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();});
 document.addEventListener('shopify:section:unload',stop);
 document.addEventListener('shopify:section:load',stop);
 window.addEventListener('blur',stop);
 motion.addEventListener('change',stop);
 fine.addEventListener('change',stop);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-convenience"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pf-shop-tools')){
class PfShopTools extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.abort=new AbortController();this.opts={signal:this.abort.signal};this.words=JSON.parse(this.querySelector('[data-qol-words]').textContent);this.memory={};this.timers=[];
  this.read=(key,fallback)=>{try{return JSON.parse(localStorage.getItem(key))??fallback;}catch(e){return this.memory[key]??fallback;}};
  this.write=(key,value)=>{this.memory[key]=value;try{localStorage.setItem(key,JSON.stringify(value));}catch(e){}};
  this.savedKey='pf-favorites-v1';this.recentKey='pf-recent-v1';
  this.items=key=>{const value=this.read(key,[]);return Array.isArray(value)?value.filter(p=>p&&typeof p.url==='string'&&p.url.startsWith('/')&&p.url.includes('/products/')&&!p.url.startsWith('//')).slice(0,50):[];};
  delete document.documentElement.dataset.pfReduce;
  try{localStorage.removeItem('pf-reduce-motion');}catch(error){}
  this.querySelectorAll('[data-close]').forEach(b=>b.addEventListener('click',()=>b.closest('dialog').close(),this.opts));
  this.querySelector('[data-clear-recent]').addEventListener('click',()=>{this.write(this.recentKey,[]);this.showList('recent');},this.opts);
  document.addEventListener('click',e=>this.handleClick(e),this.opts);
  window.addEventListener('storage',()=>this.syncHearts(),this.opts);
  window.addEventListener('pageshow',()=>this.restoreScroll(),this.opts);this.restoreScroll();
  this.current=this.querySelector('[data-current-product]')?JSON.parse(this.querySelector('[data-current-product]').textContent):null;
  if(this.current){
   this.write(this.recentKey,[this.current,...this.items(this.recentKey).filter(p=>p.handle!==this.current.handle)].slice(0,12));
   this.productTools=this.querySelector('[data-product-tools]');this.restock=this.querySelector('[data-restock]');const info=document.querySelector('product-info .product__info-container');if(info){info.append(this.productTools,this.restock);this.productObserver=new MutationObserver(()=>this.syncProduct());this.productObserver.observe(info,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled']});}
   this.productTools.querySelector('[data-save-current]').addEventListener('click',()=>this.toggleSave(this.current),this.opts);
   try{const previous=JSON.parse(sessionStorage.getItem('pf-browse-return'));if(previous&&previous.url?.startsWith('/')&&!previous.url.startsWith('//')){const a=this.productTools.querySelector('[data-back]');a.href=previous.url;a.hidden=false;}}catch(e){}
   this.querySelector('[data-sticky-buy]').addEventListener('click',()=>{const real=document.querySelector('product-info product-form button[name="add"]');if(real&&!real.disabled&&real.getAttribute('aria-disabled')!=='true')real.click();},this.opts);this.syncProduct();
  }
  this.decorate();this.installShipping();
  this.observer=new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('.product-card-wrapper,.drawer__footer,.cart__footer,cart-items')||n.querySelector?.('.product-card-wrapper,.drawer__footer,.cart__footer'))))){clearTimeout(this.decorateTimer);this.decorateTimer=setTimeout(()=>{this.decorate();this.installShipping();},100);}});
  this.observer.observe(document.body,{childList:true,subtree:true});
  document.addEventListener('change',e=>{if(e.target.closest('cart-items,cart-drawer,.cart__footer')){clearTimeout(this.cartTimer);this.cartTimer=setTimeout(()=>this.updateShipping(),900);}},this.opts);
  document.addEventListener('cart:updated',()=>this.updateShipping(),this.opts);
  window.addEventListener('focus',()=>this.updateShipping(),this.opts);
 }
 handleClick(e){
  const tool=e.target.closest('[data-qol-open]');if(tool){this.showList(tool.dataset.qolOpen);return;}
  const a=e.target.closest('a[href]');if(!a||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey||e.button!==0)return;const u=new URL(a.href,location.href);if(u.origin!==location.origin)return;
  if(u.pathname.includes('/products/')&&(location.pathname.includes('/collections/')||location.pathname.endsWith('/search'))){try{sessionStorage.setItem('pf-browse-return',JSON.stringify({url:location.pathname+location.search,y:scrollY}));}catch(error){}}
 }
 restoreScroll(){try{const state=JSON.parse(sessionStorage.getItem('pf-browse-return'));if(state?.url===location.pathname+location.search){requestAnimationFrame(()=>scrollTo(0,state.y||0));this.timers.push(setTimeout(()=>scrollTo(0,state.y||0),250));}}catch(error){}}
 decorate(){document.querySelectorAll('.product-card-wrapper').forEach(card=>{if(card.querySelector('.qol-heart'))return;const a=card.querySelector('.card__heading a[href*="/products/"]');if(!a)return;const u=new URL(a.href,location.href);const handle=u.pathname.split('/products/')[1]?.split('/')[0];if(!handle)return;const data={handle,title:a.textContent.trim(),url:u.pathname,image:card.querySelector('img')?.currentSrc||card.querySelector('img')?.src||null};const b=document.createElement('button');b.type='button';b.className='qol-heart';b.dataset.handle=handle;b.textContent='♡';b.addEventListener('click',()=>this.toggleSave(data),this.opts);card.append(b);});this.syncHearts();}
 toggleSave(product){let list=this.items(this.savedKey);list=list.some(p=>p.handle===product.handle)?list.filter(p=>p.handle!==product.handle):[product,...list].slice(0,50);this.write(this.savedKey,list);this.syncHearts();if(this.querySelector('[data-saved-dialog]').open)this.showList('saved');}
 syncHearts(){const list=this.items(this.savedKey);document.querySelectorAll('.qol-heart').forEach(b=>{const active=list.some(p=>p.handle===b.dataset.handle);b.textContent=active?'♥':'♡';b.setAttribute('aria-pressed',String(active));b.setAttribute('aria-label',active?this.words.remove:this.words.save);});if(this.current){const b=this.productTools.querySelector('[data-save-current]');const active=list.some(p=>p.handle===this.current.handle);b.setAttribute('aria-pressed',String(active));b.textContent=active?this.words.remove:this.words.save;}}
 showList(kind){const dialog=this.querySelector('[data-'+kind+'-dialog]'),grid=dialog.querySelector('[data-'+kind+'-list]');grid.replaceChildren();const list=this.items(kind==='saved'?this.savedKey:this.recentKey);if(!list.length){const p=document.createElement('p');p.textContent=this.words.empty;grid.append(p);}list.forEach(item=>{const card=document.createElement('article'),a=document.createElement('a'),p=document.createElement('p');a.href=item.url;p.textContent=item.title;if(item.image){const img=document.createElement('img');try{const url=new URL(item.image,location.href);if(['https:','http:'].includes(url.protocol)){img.src=url.href;img.alt='';img.loading='lazy';img.width=180;img.height=150;a.append(img);}}catch(e){}}a.append(p);card.append(a);if(kind==='saved'){const b=document.createElement('button');b.type='button';b.textContent=this.words.remove;b.addEventListener('click',()=>this.toggleSave(item),this.opts);card.append(b);}grid.append(card);});if(!dialog.open)dialog.showModal();}
 syncProduct(){const info=document.querySelector('product-info');if(!info)return;const real=info.querySelector('product-form button[name="add"]');const sticky=this.querySelector('[data-sticky]');if(!real){sticky.hidden=true;return;}const disabled=real.disabled||real.getAttribute('aria-disabled')==='true';const b=sticky.querySelector('button');b.disabled=disabled;b.textContent=real.textContent.trim()||this.words.buy;const price=info.querySelector('.price--on-sale .price-item--sale')||info.querySelector('.price-item--regular');sticky.querySelector('[data-sticky-price]').textContent=price?.textContent.trim()||'';sticky.hidden=false;const unavailable=disabled&&!real.classList.contains('loading');this.restock.hidden=!unavailable;const id=info.querySelector('product-form input[name="id"]')?.value||'';this.restock.querySelector('[data-restock-variant]').value=id;
 }
 installShipping(){document.querySelectorAll('.cart__footer,.drawer__footer').forEach(target=>{if(target.querySelector('.qol-shipping'))return;const fragment=this.querySelector('[data-shipping-template]').content.cloneNode(true);const select=fragment.querySelector('select');select.value=this.dataset.country==='ES'?'ES':'OTHER';select.addEventListener('change',()=>this.updateShipping(),this.opts);target.prepend(fragment);});this.updateShipping();}
 async updateShipping(){const nodes=[...document.querySelectorAll('.qol-shipping')];if(!nodes.length||this.cartBusy)return;this.cartBusy=true;try{const response=await fetch(this.dataset.root.replace(/\/$/,'')+'/cart.js',{signal:this.abort.signal});if(!response.ok)throw Error();const cart=await response.json();nodes.forEach(node=>{const eligible=node.querySelector('select').value==='ES'&&cart.currency==='EUR';const remaining=Math.max(0,15000-cart.total_price);node.querySelector('p').textContent=eligible?(remaining?this.words.remaining.replace('__AMOUNT__',new Intl.NumberFormat(document.documentElement.lang||'es',{style:'currency',currency:'EUR'}).format(remaining/100)):this.words.free):this.words.shipping_other;const bar=node.querySelector('progress');bar.hidden=!eligible;bar.value=Math.min(15000,cart.total_price);});}catch(error){nodes.forEach(node=>{node.querySelector('p').textContent=this.words.shipping_other;node.querySelector('progress').hidden=true;});}finally{this.cartBusy=false;}}
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.productObserver?.disconnect();clearTimeout(this.decorateTimer);clearTimeout(this.cartTimer);this.timers?.forEach(clearTimeout);this.productTools?.remove();this.restock?.remove();document.querySelectorAll('.qol-heart,.qol-shipping').forEach(n=>n.remove());}
}
customElements.define('pf-shop-tools',PfShopTools);
}


  } catch(e) { console.error(e); }
})();
})();
